import { ActionListQuery } from '@/modules/FileDetail/queries/actionList/actionListQuery.type';

export const actionList: { label: string; value: keyof ActionListQuery }[] = [
  { label: 'ارسال به شعبه', value: 'send_to_branch' },
  { label: 'برگشت به شعبه', value: 'back_for_correction' },
  { label: 'انصراف از کارشناسی', value: 'refer_to_branch' },
  { label: 'انتقال به درحال اجرا', value: 'move_to_in_progress' },
];
